var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F5FCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1378 9.98637C21.7152 10.5638 21.7247 11.497 21.1591 12.086L15.7422 17.7271C15.4669 18.0137 15.0891 18.1795 14.6918 18.1878L12.4164 18.2355L12.4645 15.945C12.4726 15.5566 12.6311 15.1866 12.9065 14.9127L18.4436 9.40735C19.0298 8.82442 19.9773 8.82578 20.5619 9.41038L21.1378 9.98637Z",
    fill: "#0098DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6007 8.33325C15.9688 8.33325 16.2673 8.63173 16.2673 8.99992C16.2673 9.36811 15.9688 9.66659 15.6007 9.66659H11.0007C10.2643 9.66659 9.66732 10.2635 9.66732 10.9999V18.9999C9.66732 19.7363 10.2643 20.3333 11.0007 20.3333H19.0007C19.737 20.3333 20.334 19.7363 20.334 18.9999V15.6666C20.334 15.2984 20.6325 14.9999 21.0007 14.9999C21.3688 14.9999 21.6673 15.2984 21.6673 15.6666V18.9999C21.6673 20.4727 20.4734 21.6666 19.0007 21.6666H11.0007C9.52789 21.6666 8.33398 20.4727 8.33398 18.9999V10.9999C8.33398 9.52716 9.52789 8.33325 11.0007 8.33325H15.6007Z",
    fill: "#0098DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.d7dffdd8fea9e7d5ddbe740230a0518c.svg";
export { ForwardRef as ReactComponent };